import type { EmojiResourceConfig } from '@atlaskit/emoji/emoji-resource';

/**
 * @returns A config object for Emoji Service based on the given `cloudId`
 */
export const getEmojiProviderConfig = (
	cloudId?: string,
	baseUrl: string = process.env.NODE_ENV === 'development' ? 'https://sdog.jira-dev.com' : '',
): Readonly<EmojiResourceConfig> =>
	Object.freeze({
		providers: [
			{
				url: `${baseUrl}/gateway/api/emoji/standard`,
			},
			{
				url: `${baseUrl}/gateway/api/emoji/atlassian`,
			},
			...(cloudId ? [{ url: `${baseUrl}/gateway/api/emoji/${cloudId}/site` }] : []),
		],
	});
